export default "__VITE_ASSET__e_vojyjq__"